import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { SmartFilter } from '../../components/common/SmartFilter';
import withComponentAuth from '../../hoc/withComponentAuth';

const PartnerPerformance = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <SmartFilter title="Partner Performance" enableBack createFilter={[]} />
    <Box sx={{ p: 1 }}>
      <Paper sx={{ p: 3, bgcolor: '#171717', border: '1px solid #242424', borderRadius: 2 }}>
        <Typography color="#fff" fontWeight={700} mb={1}>Coming soon</Typography>
        <Typography color="#94a3b8">Partner performance reporting will be added after the backend module exists.</Typography>
      </Paper>
    </Box>
  </Box>
);

export default withComponentAuth(PartnerPerformance);